// extracted by mini-css-extract-plugin
export var icon = "_94-3";
export var subtitle = "_94-2";
export var title = "_94-1";
export var value = "_94-0";